function runWhenInit() {
  window.liquidAjaxCart.conf('updateOnWindowFocus', false);
}

if (window.liquidAjaxCart?.init) {
  // if Liquid Ajax Cart is already initialized
  runWhenInit();
} else {
  // wait for Liquid Ajax Cart to be initialized
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);
}

document.addEventListener('DOMContentLoaded', () => {
  bindCartOpenButtons();
  bindCartCloseButton();
});

document.addEventListener('liquid-ajax-cart:request-end', event => {
  const { requestState } = event.detail;

  if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    //openCart(event);
  }

  bindCartCloseButton();
  changeNotification();
});

document.addEventListener('DOMContentLoaded', () => {
  if (new URLSearchParams(location.search).has('cart-added')) {
    document.body.classList.add('js-show-ajax-cart');
  }
});

/**
 * Updates the cart notification badge with the current item count.
 * Hides the badge if the cart is empty.
 *
 * @returns {void}
 */
function changeNotification() {
  const countCart = window.liquidAjaxCart.cart.item_count;
  const updateNotification = document.querySelector('[data-count-cart]');

  if(!updateNotification) return;
  if (countCart == 0) {
    updateNotification.classList.add('hidden');
    return
  }
  updateNotification.classList.remove('hidden');
  updateNotification.textContent = countCart;
}

/**
 * Opens the AJAX cart by adding the corresponding body class.
 * Prevents the default event action if triggered by a clickable element.
 *
 * @param {Event} [event] - The event that triggered the cart opening.
 * @returns {void}
 */
function openCart(event) {
  if (event?.preventDefault) event.preventDefault();
  document.body.classList.add('js-show-ajax-cart');
}

function restart() {
  document.body.classList.remove('js-show-ajax-cart');
}

function bindCartCloseButton() {
  const buttonsClose = document.querySelectorAll('.ajax-close-cart');
  buttonsClose.forEach(button => {
    button.addEventListener('click', restart);
  });
}

function bindCartOpenButtons() {
  const buttonsOpen = document.querySelectorAll('.ajax-open-cart');
  buttonsOpen.forEach(button => {
    button.addEventListener('click', openCart);
  });
}

  